var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.678,
    height: 24.678,
    viewBox: "0 0 24.678 24.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1894",
    "data-name": "Group 1894",
    transform: "translate(-8245 -8177.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658",
    transform: "translate(8206.385 7902.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(38.615 274.856)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 12.339,
    cy: 12.339,
    r: 12.339,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(-2375.967 1669.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M2509.16-1382.91a2.117,2.117,0,0,1-.592-1.525,2.118,2.118,0,0,1,.671-1.492,2.109,2.109,0,0,1,2.85,0,2.118,2.118,0,0,1,.672,1.492,2.119,2.119,0,0,1-.591,1.525l.139.081a3.369,3.369,0,0,1,1.747,2.88,1.2,1.2,0,0,1-.464,1.021,2.866,2.866,0,0,1-1.3.577,7.176,7.176,0,0,1-3.72-.134,2.9,2.9,0,0,1-.652-.31,1.308,1.308,0,0,1-.637-1.366,3.391,3.391,0,0,1,1.8-2.7Zm1.5,3.759c.111,0,.223.006.333,0a4.361,4.361,0,0,0,1.789-.393c.294-.152.327-.228.292-.553a2.443,2.443,0,0,0-2.475-2.185,2.445,2.445,0,0,0-2.364,2.351.3.3,0,0,0,.161.3,3.738,3.738,0,0,0,.5.238,5.246,5.246,0,0,0,1.764.243Zm.006-4.114a1.109,1.109,0,0,0,.8-.325,1.109,1.109,0,0,0,.324-.8,1.12,1.12,0,0,0-.328-.8,1.121,1.121,0,0,0-.8-.328,1.121,1.121,0,0,0-.8.326,1.121,1.121,0,0,0-.331.8,1.108,1.108,0,0,0,.326.809,1.109,1.109,0,0,0,.81.323Z",
    transform: "translate(-84.266)",
    fill: "#00a7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M2420.69-1378.05a1.64,1.64,0,0,1,.24-2.232,1.635,1.635,0,0,1,2.077-.021,1.639,1.639,0,0,1,.271,2.244c.159.13.325.253.474.393a.489.489,0,0,1,.189.349.489.489,0,0,1-.133.375.494.494,0,0,1-.369.148.5.5,0,0,1-.358-.172,1.555,1.555,0,0,0-1.5-.4,1.556,1.556,0,0,0-1.1,1.089c-.125.461-.107.464.332.62a3.542,3.542,0,0,0,1.239.159,1.05,1.05,0,0,1,.284.024.469.469,0,0,1,.337.524.472.472,0,0,1-.435.414,4.46,4.46,0,0,1-1.986-.306,1.941,1.941,0,0,1-.512-.34,1.059,1.059,0,0,1-.267-1.022,2.511,2.511,0,0,1,1.135-1.781C2420.64-1378.01,2420.66-1378.03,2420.69-1378.05Zm1.279-.353a.644.644,0,0,0,.467-.179.644.644,0,0,0,.2-.458.655.655,0,0,0-.65-.657.645.645,0,0,0-.653.635.631.631,0,0,0,.18.463.632.632,0,0,0,.459.19Z",
    transform: "translate(0 -5.578)",
    fill: "#00a7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M2652.41-1378.06a1.642,1.642,0,0,1,.276-2.263,1.632,1.632,0,0,1,2.089.047,1.64,1.64,0,0,1,.218,2.212c.1.074.206.142.3.222a2.52,2.52,0,0,1,.935,1.815,1.071,1.071,0,0,1-.618,1.085,3.257,3.257,0,0,1-1.271.357,8.292,8.292,0,0,1-.846.034.472.472,0,0,1-.35-.139.471.471,0,0,1-.137-.35.479.479,0,0,1,.148-.345.478.478,0,0,1,.352-.131,3.911,3.911,0,0,0,1.346-.153c.462-.16.474-.169.344-.638a1.558,1.558,0,0,0-1.077-1.072,1.558,1.558,0,0,0-1.477.354.935.935,0,0,1-.269.188.466.466,0,0,1-.557-.189.465.465,0,0,1,.048-.586,5.673,5.673,0,0,1,.436-.372A.43.43,0,0,1,2652.41-1378.06Zm1.3-.356a.632.632,0,0,0,.462-.189.632.632,0,0,0,.181-.465.643.643,0,0,0-.647-.64.654.654,0,0,0-.656.651.644.644,0,0,0,.2.458.644.644,0,0,0,.464.181Z",
    transform: "translate(-222.892 -5.565)",
    fill: "#00a7f0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/Staff.f0a763ddf8334c6c30cfb2eaa16fcb85.svg";
export { ForwardRef as ReactComponent };